import { ICategories, ICategoryMap } from '@components/Post/interfaces';
import { AllPostsQuery } from '@src/generated/graphql';
import sdk from '@src/lib/sdk';

export const handleCategories = async (
  allPosts: AllPostsQuery
): Promise<ICategories> => {
  const categoriesData = await sdk.Categories();

  const categoriesMap = categoriesData.allPostCategory.reduce(
    (acc, category) => {
      acc[category.slug?.current ?? ''] = {
        title: category.title ?? '',
        count: 0,
      };
      return acc;
    },
    {} as ICategoryMap
  );

  allPosts.allPost.forEach(({ category }) => {
    const catSlug = category?.slug?.current ?? '';
    categoriesMap[catSlug].count += 1;
  });
  const categories = Object.keys(categoriesMap).map((key) => {
    const { count, title } = categoriesMap[key];
    return {
      slug: key,
      title,
      count,
    };
  });
  return categories;
};
